import { useTranslation } from "react-i18next";
import { DIRECTION } from "services/general";
import NotificationsPanel from "./NotificationsPanel";

/**
 * NotificationsPopupMenu — compact dropdown popup shown on tablet/desktop
 * widths (>= 640px) when the notifications bell is open. Anchored and
 * RTL-flipped the same way as MoreToolsPopupMenu, rather than relying on
 * AntD Popover's placement maths (which does not mirror for RTL and was
 * overflowing on narrow/RTL viewports).
 */
const NotificationsPopupMenu = ({
  count,
  loading,
  markAllRead,
  notifications,
  fetchLoading,
  handleOpenNotification,
  handleViewAll,
}) => {
  const { t } = useTranslation();

  return (
    <div
      className={`hidden sm:block absolute top-full mt-2 ${
        DIRECTION === "rtl" ? "left-0" : "right-0"
      } w-[340px] max-w-[90vw] bg-surface rounded-xl shadow-lg border border-border-light z-[100] overflow-hidden`}
    >
      <NotificationsPanel
        t={t}
        count={count}
        loading={loading}
        markAllRead={markAllRead}
        notifications={notifications}
        fetchLoading={fetchLoading}
        handleOpenNotification={handleOpenNotification}
        handleViewAll={handleViewAll}
      />
    </div>
  );
};

export default NotificationsPopupMenu;
